/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default (props) => {
  useEffect(() => {
    props.listIntent(props.token);
  }, []);

  const intents = useSelector((state) => {
    return state.intelligence.intents.sort(function (a, b) {
      return (a.cleanName > b.cleanName) ? 1 : ((b.cleanName > a.cleanName) ? -1 : 0);
    });
  });

  const selectIntentMenu = (value) => {
    props.doUpdateItemWithDebounce({
      menuItems: props.itemData.menuItems.map((elem) =>
        elem._id !== props.menuItem._id
          ? elem
          : { ...props.menuItem, intent: value }
      ),
    });
  };

  return (
    <select
      className="selectIntent"
      onChange={(e) => selectIntentMenu(e.target.value)}
    >
      {!!props.token ? (
        props?.menuItem?.intent ? (
          intents.map((intent) => {
            return (
              <>
                {props?.menuItem?.intent === intent.cleanName ? (
                  <option className="optionIntent" selected value={intent.cleanName}>
                    {intent.name}
                  </option>
                ) : (
                  <option className="optionIntent" value={intent.cleanName}>
                    {intent.name}
                  </option>
                )}
              </>
            );
          })
        ) : (
          <>
            <option className="optionIntent" value="empty" disabled selected>
              Escolha uma intenção
            </option>
            {intents.map((intent) => {
              return (
                <option className="optionIntent" value={intent.cleanName}>
                  {intent.name}
                </option>
              );
            })}
          </>
        )
      ) : (
        <option className="optionIntent" disabled selected value="null">
          Sem intenções
        </option>
      )}
    </select>
  );
};
